export default "__VITE_ASSET__rX9iRGIf__"